import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="h-10 w-10 border-[3px] border-slate-200 border-t-slate-900 rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  // Card-first policy: any non-admin without a card must complete onboarding before the app.
  if (user.requires_card_setup && !user.is_platform_admin) {
    return <Navigate to="/onboarding/card" replace />;
  }
  return children;
}
